import React from "react";

const MonthlyPnlTable = ({ headers, rows }) => {
  const calculateTotalPnl = (monthlyPnl) => {
    return monthlyPnl?.reduce((total, item) => total + item.pnl, 0).toFixed(0);
  };
  return (
    <div className="z-0  animate-reveal transition-all duration-500 ease-in">
      <table className="bg-black border border-gray-700 text-sm w-full relative z-0">
        <thead className="bg-[#0F0F0F] text-sm text-left">
          <tr className="text-white border-b border-gray-800">
            {headers.map((header, index) => (
              <th
                key={index}
                className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
            >
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900`}
              >
                {row.strategy}
              </td>

              {row.monthly_pnl?.map((item,idx) => (
                <td
                key={idx}
                  className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-right ${
                    item.pnl > 0
                      ? "text-green-400"
                      : item.pnl < 0
                      ? "text-rose-500"
                      : "text-white"
                  }`}
                >
                  {item.pnl.toFixed(0)}
                </td>
              ))}

              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-right  ${
                  calculateTotalPnl(row.monthly_pnl) > 0
                    ? "text-green-400"
                    : calculateTotalPnl(row.monthly_pnl) < 0
                    ? "text-rose-500"
                    : "text-white"
                }`}
              >
                {calculateTotalPnl(row.monthly_pnl)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MonthlyPnlTable;
